import __request__ from "routing/request";
export function startReplication() {
  return __request__("POST", "/datanodes/upgrade/replication/start", null, {}, {
    "Accept": ["application/json"]
  });
}
export function stopReplication() {
  return __request__("POST", "/datanodes/upgrade/replication/stop", null, {}, {
    "Accept": ["application/json"]
  });
}
export function status() {
  return __request__("GET", "/datanodes/upgrade/status", null, {}, {
    "Accept": ["application/json"]
  });
}
